import { useCallback, useEffect, useState } from 'react';

import type { OneInchNetwork, OneInchToken } from '@api';

import displayWalletErrorToast from '@shared/helpers/displayWalletErrorToast';

import { useGetTokenPriceInUSDQuery } from '@query/magicSwap';

const useTokenPriceInUSD = ({
  network,
  token,
  fromAmount,
  inverted,
}: {
  network?: OneInchNetwork;
  token?: OneInchToken;
  fromAmount?: number;
  inverted?: boolean;
}) => {
  const { refetch, isPending: isLoading } = useGetTokenPriceInUSDQuery({
    networkId: network?.id,
    tokenAddress: token?.id,
    options: { enabled: false },
  });

  const [tokenPriceInUSD, setTokenPriceInUSD] = useState(0);

  const getTokenBalanceInUSD = useCallback(async () => {
    if (!network || !token) {
      setTokenPriceInUSD(0);
      return;
    }

    try {
      const { data: price } = await refetch();

      if (price) {
        setTokenPriceInUSD(price.attributes.price);
      }
    } catch (error) {
      displayWalletErrorToast({ error });
      setTokenPriceInUSD(0);
    }
  }, [network, token, setTokenPriceInUSD, refetch]);

  useEffect(() => {
    if (!tokenPriceInUSD) {
      getTokenBalanceInUSD();
    }
  }, [getTokenBalanceInUSD, tokenPriceInUSD, fromAmount]);

  useEffect(() => {
    getTokenBalanceInUSD();
  }, [getTokenBalanceInUSD, inverted]);

  return {
    tokenPriceInUSD,
    isLoading,
    refetch: getTokenBalanceInUSD,
  };
};

export default useTokenPriceInUSD;
